export default __webpack_public_path__ + "static/media/logo.61e9368b.png";